<template>
    <div>

        <h2 class="ml-3 mb-3"> <feather-icon icon="EditIcon" size="22" />{{ $t('events') }} </h2>


        <div class="loading_page" v-if="loading">
            <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <app-timeline>
            <div v-for="comment in  comments" :key="comment.id">

                <app-timeline-item class="custom-item" :title="comment.commented_by" :subtitleArray="comment.comment"
                    icon="EditIcon" variant="success" />

            </div>

        </app-timeline>


    </div>
</template>

<script>
import { onUnmounted, ref, onMounted } from '@vue/composition-api'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import DynamicToggleCollapse from '@/views/ui/toggle-collapse/DynamicToggleCollapse.vue'
import axios from '@axios'
import { eventBus } from '@/main'
import {
    BCollapse,
    BCard
} from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
export default {
    components: {
        AppTimeline,
        AppTimelineItem,
        DynamicToggleCollapse,
        BCollapse,
        BCard,
        OrbitSpinner
    },
    props: {
        params: {
            type: Object,


        }

    },


    data() {
        return {
            visible: true
        }
    },

    setup(props, { root }) {
        const comments = ref([])
        const loading = ref(false);
        onMounted(() => {
            getComments(props.params)
        })

        eventBus.$on("newComment", function (data) {


            if (data.commentable_id == props.params.commentable_id && data.commentable_type == "plan") {

                comments.value.push({ commented_by: data.commented_by, comment: [data.created_at, data.comment] })
            }
            if (data.commentable_id == props.params.commentable_id && data.commentable_type == "geofence") {

             comments.value.push({ commented_by: data.commented_by, comment: [data.created_at, data.comment] })
           }

        })


        const reformatComments = (comments) => {
            let out = [];
            comments.map((item, index) => {
                out[index] = { commented_by: item.commented_by, comment: [item.created_at, item.comment] }
            })
            return out;
        }
        const getComments = (params) => {
            loading.value = true;
            return new Promise((resolve, reject) => {
                axios.get(`comments`, { params })
                    .then(res => {
                        comments.value = reformatComments(res.data)
                        loading.value = false;
                    })
                    .catch(reason => { loading.value = false; console.log(reason) })
            })
        }


        return { comments, loading }



    }
}
</script>
<style scoped>
.custom-item {
    padding-bottom: 2rem;
}
</style>